<template>
  <vue-select
    style="width: 100%"
    :value="value"
    @search="getOptions"
    id="jurusan"
    :options="items"
    label="label"
    class="select-x"
    placeholder="Jalur Masuk"
    @input="changed"
  ></vue-select>
</template>

<script>
import { HTTPAUTH } from "../lib/httplib";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  components: {
    VueSelect,
  },
  name: "EntranceMajor",
  data() {
    return {
      items: [],
    };
  },
  props: ["value"],
  created() {
    this.init("");
  },
  methods: {
    init(q) {
      HTTPAUTH.get(`/api/v1/entrance-major?q=${q}`).then((res) => {
        this.items = res.data.data;
      });
    },
    getOptions(search, loading) {
      loading(true);
      this.init(search);
      loading(false);
    },
    changed(evt) {
      this.$emit("input", evt);
    },
  },
};
</script>

<style scoped>
</style>
